import { Button, Card, DatePicker, Layout, Typography } from "antd";
// == Import CSS
import "./Extract.less";

import { MdFileDownload } from "react-icons/md";

import moment from "moment";
import { useEffect, useState } from "react";
import { isNil } from "ramda";
import { useTranslation } from "react-i18next";
import { API, extractVisits } from "services/features/VisitsSlice";
import { useDispatch } from "react-redux";

const Extract = () => {
  const [t] = useTranslation();

  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [isDisabled, setDisabled] = useState(true);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!isNil(startDate) && !isNil(endDate)) {
      setDisabled(false);
    }
  }, [endDate, startDate]);

  return (
    <div className="dashboardContainer" style={{ height: "100%", paddingTop: "130px" }}>
      <Layout>
        <Card
          title={
            <Typography.Title level={5} style={{ textAlign: "center" }}>
              {t("ExtractVisit")}
            </Typography.Title>
          }
        >
          <div style={{ display: "flex", justifyContent: "center" }}>
            <div style={{ display: "flex", flexFlow: "column" }}>
              <Typography.Text>{t("StartDate")}</Typography.Text>
              <DatePicker
                style={{ marginRight: "16px" }}
                onChange={value => {
                  setStartDate(value);
                }}
              />
            </div>

            <div style={{ display: "flex", flexFlow: "column" }}>
              <Typography.Text>{t("EndDate")}</Typography.Text>
              <DatePicker
                onChange={value => {
                  setEndDate(value);
                }}
              />
            </div>
          </div>
          <div style={{ display: "flex", justifyContent: "center", marginTop: "20px" }}>
            <Button
              disabled={isDisabled}
              onClick={() =>
                dispatch(
                  extractVisits(moment(startDate).toISOString(), moment(endDate).toISOString()),
                )
              }
              icon={<MdFileDownload style={{ verticalAlign: "-4px", marginRight: "8px" }} />}
              type="primary"
            >
              {t("Extract")}
            </Button>
          </div>
        </Card>
      </Layout>
    </div>
  );
};

export default Extract;
